import { atom } from "recoil";
// 型定義
export type Export = {
  [key: string]: string;
};
export const filteredArrayState = atom<Export[]>({
  key: "filteredArrayState",
  default: [],
});
